import React from 'react';
import FAQS from './stores/FAQs';
import QuestionsAndAnswers from './components/QuestionsAndAnswers';

const FAQsComponent = (props) => {
  const faqs = new FAQS(props);
  return <QuestionsAndAnswers faqs={faqs.questions} />;
};

export default FAQsComponent;
